// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".pdf-output-page-header[data-v-17954428]{width:calc(100% - var(--sidebar-x-offset))}.toolbar[data-v-17954428]{position:fixed;right:0;z-index:14;transition:width .2s cubic-bezier(.4,0,.2,1)}.page-title[data-v-17954428]{color:var(--v-gray-ultra-dark);font-size:24px;letter-spacing:.2px;margin-left:var(--spacer)}", ""]);
// Exports
module.exports = exports;
